"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeGestionUtiliseTrads = void 0;
exports.ESubModeGestionUtiliseTrads = {
    conseillee: "Gestion conseillée",
    direct: "Gestion directe",
    sous_mandat: "Gestion sous mandat",
};
